import { InsightContentSettingType } from 'components/insightContent/types'
import { SocialWebPopularPostsWidget } from 'schemas/SocialWebPopularPostsWidgetSchema'
import AnalysisFilter from 'types/analysisFilter'
import { PostMetric } from 'schemas/PostMetricSchema'
import { Post } from 'schemas/PostSchema'
import i18n from 'i18n'

import { toFilter } from '../../../../../utils/widgetUtil'

export const convertToInsightContentSetting = (
  widgetSetting: SocialWebPopularPostsWidget,
  selection?: { posts: Array<PostMetric> }
) => {
  const insightContentSetting = {
    viewOption: widgetSetting.viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const posts = selection?.posts || []
  const filter = toFilter(widgetSetting)

  insightContentSetting.selectionName = i18n.t('selectedPost', { count: posts.length })

  filter.parentDocIds = []
  for (let i = 0; i < posts.length; i += 1) {
    filter.parentDocIds.push(posts[i].postId)
  }

  const postFilter = posts.map((post) => ({
    domain: post.domain,
    postID: post.postId
  }))

  filter.includedPosts = [postFilter]

  insightContentSetting.selectionFilter = filter
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: SocialWebPopularPostsWidget,
  selection?: { posts?: Array<PostMetric> }
) => {
  if (widgetSetting && typeof widgetSetting === 'object') {
    const convertedWidgetSetting = {} as SocialWebPopularPostsWidget

    const keys = Object.keys(widgetSetting) as Array<keyof SocialWebPopularPostsWidget>

    keys.forEach((key) => {
      if (widgetSetting[key] != null) {
        // @ts-ignore
        convertedWidgetSetting[key] = widgetSetting[key]!
      }
    })

    const insights = selection ? selection?.posts : null

    if (insights && insights.length > 0) {
      const posts = selection?.posts || []
      const postFilter = []
      for (let j = 0; j < posts.length; j += 1) {
        const post = {} as Post
        post.domain = posts[j].domain
        post.postID = posts[j].postId
        postFilter.push(post)
      }

      convertedWidgetSetting.includedPosts = [postFilter]
    }
    return convertedWidgetSetting
  }
  return {}
}
